/* eslint-disable react-refresh/only-export-components */
import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const badgeVariants = cva(
  'inline-flex items-center justify-center font-semibold gap-1 px-2 py-0.5 text-xs transition-colors focus:outline-none focus:ring-2 focus:ring-neutrals-N500 focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary-blue-B600 text-neutrals-N100 shadow hover:bg-primary-blue-B600/80',
        secondary:
          'border-transparent bg-neutrals-N500 text-neutrals-N900 hover:bg-neutrals-N500/40',
        destructive:
          'border-transparent bg-primary-red-R400 text-neutrals-N100 shadow hover:bg-primary-red-R200',
        'secondary-indigo':
          'border-transparent bg-secondary-indigo-I500 text-neutrals-N100',
        outline: 'text-neutrals-N900',
      },
      type: {
        pill: 'rounded-full',
        rectangle: 'rounded-md',
      },
    },
    defaultVariants: {
      variant: 'default',
      type: 'rectangle',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, type, ...props }: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, type }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
